__turbopack_context__.v({
  "stub": "Stub-module-scss-module__U3S8PW__stub",
  "stub__intent": "Stub-module-scss-module__U3S8PW__stub__intent",
  "stub__label": "Stub-module-scss-module__U3S8PW__stub__label",
  "stub__name": "Stub-module-scss-module__U3S8PW__stub__name",
  "stub__slot": "Stub-module-scss-module__U3S8PW__stub__slot",
  "stub__tag": "Stub-module-scss-module__U3S8PW__stub__tag",
});
